export const routeProps = {
  path: '/order_topups/(choose|review)',
  exact: true,
};

export default (step = 'choose') => `/order_topups/${step}`;
